import { inject } from "@angular/core";
import { CanActivateFn, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { Web3StateService } from "../+state/web3.state.service";
import { extractBasePath } from "@modules/trade/helpers/helper";
import { Web3NavigationService } from "../services/web3.navigation";

export const migrationSuccessGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
	const signal = inject(Web3StateService);
	const navigation = inject(Web3NavigationService);

	const basePath = extractBasePath(state.url);

	if (signal.$successSignal()) {
		return of(true);
	}

	return of(navigation.createUrlTree(basePath));
};
